import { render, staticRenderFns } from "./MenuTransporter.vue?vue&type=template&id=246c4aab&scoped=true&"
import script from "./MenuTransporter.vue?vue&type=script&lang=js&"
export * from "./MenuTransporter.vue?vue&type=script&lang=js&"
import style0 from "./MenuTransporter.vue?vue&type=style&index=0&id=246c4aab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246c4aab",
  null
  
)

export default component.exports